import { render, staticRenderFns } from "./FundingDeliveryPartnerRequestsIndex.vue?vue&type=template&id=4fef9eed&"
import script from "./FundingDeliveryPartnerRequestsIndex.vue?vue&type=script&lang=js&"
export * from "./FundingDeliveryPartnerRequestsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports